import { useState } from 'react';
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const faqs = [
    {
      question: '利用料金について教えてください',
      answer: 'ご利用料金は企業規模やご利用内容によって異なります。まずはお問い合わせいただき、貴社のニーズをお聞かせください。最適なプランをご提案させていただきます。'
    },
    {
      question: '対応エリアはどこまでですか?',
      answer: 'オンラインカウンセリングのため、全国どこからでもご利用いただけます。インターネット環境があれば、場所を問わずサービスをご提供できます。'
    },
    {
      question: 'カウンセリングの頻度はどのくらいですか?',
      answer: '従業員の方のご希望やご状況に応じて柔軟に対応いたします。週1回から月1回程度が一般的ですが、必要に応じて頻度を調整することも可能です。'
    },
    {
      question: '秘密保持はどのように守られますか?',
      answer: 'カウンセリング内容は厳重に管理され、ご本人の同意なく企業様に開示することはございません。ただし、企業様との連携が必要な場合は、ご本人の同意を得た上で必要最小限の情報を共有いたします。'
    },
    {
      question: '最低利用期間はありますか?',
      answer: '基本的には6ヶ月からのご契約をお願いしております。メンタルヘルスケアは継続的な取り組みが重要であり、一定期間のご利用により効果を実感していただけます。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="min-h-screen py-24 bg-white flex items-center">
      <div 
        ref={ref}
        className={`max-w-4xl mx-auto px-6 w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3B5C] mb-4">
            よくある質問
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`border-b border-gray-200 last:border-b-0 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full py-6 flex items-start gap-4 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FF6B6B] flex items-center justify-center">
                  <span className="text-white text-sm font-bold">Q</span>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#1A3B5C] mb-2">
                    {faq.question}
                  </h3>
                  
                  {openIndex === index && (
                    <div className="mt-4 pl-4 border-l-2 border-[#E8F4F8]">
                      <p className="text-sm text-gray-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
                
                <div className="flex-shrink-0">
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-[#1A3B5C] transition-transform`}></i>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
